import { useCallback } from 'react';

import { PharmindexIntegrateManuallyCommand } from '@dreryk/medicine-database-pharmindex-api';

import { Button, ButtonVariant, Loader, LoaderSize } from '@dreryk/react-components';
import { useCqrsCommand } from '@dreryk/command-query-react-common';

import { HandleSetIntegrationInProgress } from './PharmindexIntegrationPanel';

type StartIntegrationButtonProps = {
   readonly integrationInProgress: boolean;
   readonly handleSetIntegrationInProgress: HandleSetIntegrationInProgress;
};

const StartIntegrationButton = (props: StartIntegrationButtonProps): JSX.Element => {
   const { executeAsync: integrateManually } = useCqrsCommand<void, void>(() => {
      return new PharmindexIntegrateManuallyCommand();
   });
   const startIntegration = useCallback(async () => {
      props.handleSetIntegrationInProgress(true);
      await integrateManually();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   if (props.integrationInProgress) {
      return <Loader size={LoaderSize.MEDIUM} testId={'startIntegration'} />;
   }
   return (
      <Button
         label={'medicineDatabasePharmindex:integration.startIntegration'}
         onClick={startIntegration}
         disabled={props.integrationInProgress}
         variant={ButtonVariant.PRIMARY}
         testId={'startIntegration'}
      />
   );
};

export default StartIntegrationButton;
